import api from "@/api/axios";
import { ApiResponse } from "@/types/apiResponse";
import { Social } from "@/types/socials";

export async function fetchSocials() {
  const res = await api.get<ApiResponse<Social[]>>("/socials");

  return res.data.data;
}
